import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ArrowLoop = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M17.712 10.287L13.712 6.287C13.537 6.112 13.287 6 12.999 6C12.449 6 11.999 6.45 11.999 7C11.999 7.275 12.112 7.525 12.286 7.713L14.586 10H7.99799C4.68499 10 1.99799 12.688 1.99799 16C1.99799 19.312 4.68599 22 7.99799 22H8.99799C9.54799 22 9.99799 21.55 9.99799 21C9.99799 20.45 9.54799 20 8.99799 20H7.99799C5.79799 20 3.99799 18.2 3.99799 16C3.99799 13.8 5.79799 12 7.99799 12H14.586L12.299 14.287C12.124 14.462 12.012 14.712 12.012 15C12.012 15.55 12.462 16 13.012 16C13.287 16 13.537 15.887 13.725 15.713L17.725 11.713C17.9 11.538 18.013 11.288 18.013 11C18.013 10.712 17.888 10.475 17.713 10.287H17.712Z" />
		<path d="M24 10H23C22.45 10 22 10.45 22 11C22 11.55 22.45 12 23 12H24C26.2 12 28 13.8 28 16C28 18.2 26.2 20 24 20H17.413L19.701 17.712C19.876 17.537 19.989 17.287 19.989 17C19.989 16.45 19.539 16 18.989 16C18.714 16 18.464 16.113 18.277 16.288L14.277 20.288C14.102 20.463 13.99 20.713 13.99 21C13.99 21.287 14.103 21.525 14.277 21.712L18.277 25.712C18.452 25.887 18.702 26 18.989 26C19.539 26 19.989 25.55 19.989 25C19.989 24.725 19.876 24.475 19.701 24.288L17.413 22H24C27.313 22 30 19.312 30 16C30 12.688 27.312 10 24 10Z" />
	</svg>
);

export default ArrowLoop;
